import { render, staticRenderFns } from "./imageUpload.vue?vue&type=template&id=15e89298&"
import script from "./imageUpload.vue?vue&type=script&lang=js&"
export * from "./imageUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\00_GIT\\hotel\\hotel-front-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15e89298')) {
      api.createRecord('15e89298', component.options)
    } else {
      api.reload('15e89298', component.options)
    }
    module.hot.accept("./imageUpload.vue?vue&type=template&id=15e89298&", function () {
      api.rerender('15e89298', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/components/imageUpload.vue"
export default component.exports